import { useCallback } from 'react'
import ToursSplitPayScreen from '../split/[token]'
import { seedToursSplit } from '../../preview/seed'
import { PreviewSeedBoundary } from '../../preview/PreviewSeedBoundary'

export default function PreviewSplitRoute() {
  const seed = useCallback(() => seedToursSplit('preview-token'), [])

  return (
    <PreviewSeedBoundary seed={seed} seedKey="split:preview-token">
      <ToursSplitPayScreen />
    </PreviewSeedBoundary>
  )
}
